import _ from 'underscore';

export default class OrderDocumentsContacts {
  constructor($scope, $rootScope, UserService) {
    function load_data(user_id) {
      $scope.contacts = [];
      UserService.get_contacts(user_id).success(function(data) {
        $scope.contacts = _.filter(data.contacts, function(c) {
          return !_.isEmpty(c.email);
        });
        $rootScope.$broadcast('publish_contacts', {
          contacts: $scope.contacts
        });
      });
    }

    $scope.check_contacts = function() {
      _.each($scope.contacts, function(contact) {
        contact.checked = $scope.checked_all_contacts;
      });
    };

    $scope.init = function(user_id) {
      load_data(user_id);
    };

    $scope.init();
  }
}

OrderDocumentsContacts.$inject = ['$scope', '$rootScope', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-documents-contacts.ctrl.js